import { msg } from '@lingui/core/macro';

import { action, type AgentText, type ScreenAction } from '@/shared/screen';

import type { FilterField, FilterSet, FilterValues } from './define-filters';

/**
 * A ação `navigate` de filtrar a lista (U23): o agente e a página personalizada filtram pelo mesmo
 * caminho que a barra, com o input gerado pelos filtros. Os filtros que não vierem saem da URL.
 */
export function filterAction<Fs extends readonly FilterField[]>(
  id: string,
  set: FilterSet<Fs>,
  options: { readonly description?: AgentText } = {},
): ScreenAction<FilterValues<Fs>> {
  const keys = set.keys.join(', ');
  return action<FilterValues<Fs>>({
    id,
    kind: 'navigate',
    page: true,
    label: msg`Filtrar a lista`,
    description:
      options.description ??
      msg`Filtra a lista da tela. Filtro omitido é limpo; datas são civis (AAAA-MM-DD). Chaves: ${keys}.`,
    input: set.inputSchema,
    run: ({ nav, input }) => nav.search(set.patch(input)),
  });
}
